import { render } from "./TheProfessionalVideos.vue?vue&type=template&id=3902bf95&scoped=true&ts=true"
import script from "./TheProfessionalVideos.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalVideos.vue?vue&type=script&lang=ts"

import "./TheProfessionalVideos.vue?vue&type=style&index=0&id=3902bf95&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3902bf95"]])

export default __exports__